import { FCX } from '@datassential/platform-ui-lib';

export const InstantChartsColumnFooter: FCX = ({ children }) => (
    <div className="InstantCharts__column-footer">
        {children}
    </div>
);
